/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { GenerateCustomColumn, convertColumndef, convertRowData } from '../../common/tableConfig/questionConfig';
import questionStyle from '../../component/QuesitionAnalysis/questionanalysis.scss';
import style from '../../styles.module.scss';
import tableStyle from '../../component/common/style/index.scss';
import { EDWDropDown } from '../common/dropDown/DropDown';
import { ErrorMessage } from '../common/messaging/ErrorMessage';
import EDW_CONST from '../../common/constants'

export default class IsNoBlind extends React.Component {
    constructor(props) {
        super();
        this.state = {
            coloumnDef: props.coloumnDef,
            rowData: props.rowData,
            icons: props.questionConfig.icons,
            defaultColDef: props.defaultColDef,
            height: props.height,
            isColorblind: props.isColorblind,
            questionConfig: props.questionConfig,
            viewBy: props.viewBy,
            defaultColumns: props.customColumn,
            customColumn: props.customColumn,
            isDataExist: props.isDataExist,
            colorBlindview: props.colorBlindview,
            pinnedTopRow: props.pinnedTopRow
        };
        this.divRef = React.createRef()
    }
    componentDidMount() {

    }
    generateGridConfig(questionConfig, isColorblind, viewBy, customColumn) {

        let columndef = convertColumndef(false, viewBy, questionConfig, customColumn);
        let rowData = convertRowData(isColorblind, questionConfig);
        let height = 70 + (parseInt(rowData.rowsArray.length) + parseInt(rowData.pinnedTopRow.length)) * 50;
        this.setState({ rowData: rowData.rowsArray, pinnedTopRow: rowData.pinnedTopRow, coloumnDef: columndef ,height: height });
        this.props.updateExportData({ type: "quesiton_widget_2", rowData: rowData, columnDefs: columndef });      
    }
    sortByView = (value) => {
        if(value != this.state.viewBy){
            let customArray = GenerateCustomColumn(this.state.questionConfig, value);
            this.setState({ viewBy: value, customColumn: customArray, defaultColumns: customArray });
            this.generateGridConfig(this.state.questionConfig, this.state.isColorblind, value, customArray);
            this.gridApi.setColumnDefs(this.state.columndef);
        }       
    }
    toggleDropdown = (e) => {
        var elem = (e.target.nextElementSibling == null) ? this.divRef.current.classList : e.target.nextElementSibling.classList;
        elem.contains('show') ? elem.remove('show') : elem.add('show');
    };

    columnCustomize = (newCustomList) => {
        var customArray = this.state.defaultColumns.filter(
            item => newCustomList.indexOf(item) !== -1 || item === 'firstName' || item == 'lastName'
        );

        // var index = customArray.indexOf(e.target.value)
        // if (index !== -1) {
        //     customArray.splice(index, 1);
        // } else {
        //     var nextIndex = 0;
        //     if (key > 4) {
        //         let qNo = e.target.value.split('q');
        //         let nextColumn = '';
        //         customArray.some(function (value, i, customArray) {
        //             if (i > 4) {
        //                 let q = value.split('q');
        //                 nextColumn = value;
        //                 return parseInt(qNo[1]) < parseInt(q[1]);
        //             }
        //         });
        //         nextIndex = customArray.indexOf(nextColumn);
        //     } else {
        //         nextIndex = key;
        //     }

        //     customArray.splice(nextIndex, 0, e.target.value);

        // }
        const questionConfig = this.state.questionConfig;
        questionConfig['customColumn'] = customArray;
        this.setState({ questionConfig: questionConfig, customColumn: customArray })
        this.generateGridConfig(this.state.questionConfig, this.state.isColorblind, this.state.viewBy, customArray);
        this.gridApi.setColumnDefs(this.state.columndef);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.refreshCells(params);
        this.gridApi.setColumnDefs(this.state.coloumnDef);
    };

    isKs4 = data => {
        return data && data.toLowerCase().indexOf('edexcel') > -1
    }
    componentDidUpdate(){
        this.props.updateExportData({ type: "quesiton_widget_2", rowData: { rowsArray: this.state.rowData, pinnedTopRow:this.state.pinnedTopRow}, columnDefs: this.state.coloumnDef });      
    }
    sort_by_key = (array, key) => {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    onSortChanged = (params) => {
        let sortModel = params.api.getSortModel();
        console.log(sortModel)
        let sortedRowData = this.sort_by_key(this.state.rowData, sortModel[0]["colId"]);
        this.setState({ rowData: sortedRowData });
    }

    render() {
        return (
            <div>
                <div className="col">
                    <div className="row contentFilter content-row-padding" style={{ alignItems: 'flex-end' }}>
                        <div style={{ flex: 1, marginRight: 20 }}></div>
                        {this.state.isDataExist ? (
                            <div style={{marginRight: 20}} className={['checkboxCls', style.customCheckbox].join(" ")}>
                                <input type="checkbox" id="colorblind" className="checkbox" value={this.state.isColorblind} onChange={this.state.colorBlindview} checked={this.state.isColorblind} />
                                <label for="colorblind">Enable colourblind-friendly mode</label>
                            </div>

                        ) : (<div style={{marginRight: 20}} className="checkboxCls">

                        </div>)}
                        <div style={{ padding: 0, marginRight: 20 }}>
                            <label className={style.lblColor}>View question data as</label>
                            <EDWDropDown
                                items={this.isKs4(this.props.courseName || '') ? [
                                    { label: 'View marks', id: 'mark' },
                                    { label: 'View percentage', id: 'percentage' },
                                ] : [
                                    { label: 'Steps', id: 'steps' },
                                    { label: 'View marks', id: 'mark' },
                                    { label: 'View percentage', id: 'percentage' },
                                ]}
                                onChange={this.sortByView}
                                label="View question data as"
                                value={this.state.viewBy}
                            />
                        </div>
                        <div style={{ padding: 0, minWidth: 200 }}>
                            <label className={style.lblColor}>Show columns</label>
                            <EDWDropDown
                                items={this.state.defaultColumns.filter(
                                    id => id !== 'firstName' && id !== 'lastName'
                                ).map(id => {
                                    return {
                                        id, label: id.charAt(0).toUpperCase() + id.slice(1)
                                    }
                                })}
                                onChange={this.columnCustomize}
                                label="All"
                                multiple
                                value={this.state.customColumn.filter(id => id !== 'firstName' && id !== 'lastName')}
                            />
                        </div>
                    </div>
                    <div className="row content-row-padding">
                        <div className="labelMarkleft checkboxCls" style={{display: 'flex', marginRight: 42}}>
                            <i className={[tableStyle.lowMarkcolor, 'iconAverage'].join(' ')} style={{marginRight: 12}}></i>
                            <p>Mark is low</p>
                        </div>
                        <div className="labelMarkRight checkboxCls" style={{display: 'flex'}}>
                            <i className={[tableStyle.midrangeMarkcolor, 'iconAverage'].join(' ')} style={{marginRight: 12}}></i>
                            <p>Mark is mid-range</p>
                        </div>
                        <div className="col-md-7"></div>
                    </div>
                    {
                        this.state.questionConfig.duplicateYearError && (
                            <div className='row'>
                                <ErrorMessage message={EDW_CONST.DUPLICATE_YEAR_ERR_MSG} />
                            </div>
                        )
                    }
                </div>
                <div className="ag-theme-alpine" id="blind" style={{ height:'', width: 'auto' }}>
                    <AgGridReact tooltipShowDelay={0}
                        columnDefs={this.state.coloumnDef}
                        rowData={this.state.rowData}
                        icons={this.state.icons}
                        defaultColDef={this.state.defaultColDef}
                        onGridReady={this.onGridReady}
                        pinnedTopRowData={this.state.pinnedTopRow}
                        domLayout="autoHeight"
                        onColumnResized={this.props.onColumnResized}
                        onSortChanged={this.onSortChanged.bind(this)}
                       
                    // pagination={true}
                    // paginationPageSize={12}
                    // icons={this.state.icons}
                    // onCellClicked={this.onCellClicked}

                    >
                    </AgGridReact>
                </div>
            </div>
        )
    }
}